var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list" },
    _vm._l(_vm.list, function(item, index) {
      return _c("div", [
        item.news_type != 4
          ? _c("div", { staticClass: "media media-1" }, [
              _c("div", { staticClass: "media-left" }, [
                _c(
                  "i",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.view_tag,
                        expression: "item.view_tag"
                      }
                    ]
                  },
                  [_vm._v(_vm._s(item.view_tag))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 1,
                        expression: "item.open_type==1"
                      }
                    ],
                    attrs: { href: item.third_url, target: "_blank" }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: {
                            loading: _vm.lazyLoading,
                            error: _vm.lazyLoading,
                            src: item.img_url[0]
                          },
                          expression:
                            "{\n                            loading: lazyLoading,\n                            error: lazyLoading,\n                            src: item.img_url[0]\n                          }"
                        }
                      ],
                      attrs: { "data-src": "/public/w/img/wap/loading.png" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 0,
                        expression: "item.open_type==0"
                      }
                    ],
                    attrs: { href: "/news/" + item.id, target: "_blank" }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: {
                            loading: _vm.lazyLoading,
                            error: _vm.lazyLoading,
                            src: item.img_url[0]
                          },
                          expression:
                            "{\n                        loading: lazyLoading,\n                        error: lazyLoading,\n                        src: item.img_url[0]\n                      }"
                        }
                      ],
                      attrs: { "data-src": "/public/w/img/wap/loading.png" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "media-body" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 1,
                        expression: "item.open_type==1"
                      }
                    ],
                    attrs: { href: item.third_url, target: "_blank" }
                  },
                  [
                    _c("h1", {
                      staticClass: "media-heading textone-1",
                      domProps: { innerHTML: _vm._s(item.title) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 0,
                        expression: "item.open_type==0"
                      }
                    ],
                    attrs: { href: "/news/" + item.id, target: "_blank" }
                  },
                  [
                    _c("h1", {
                      staticClass: "media-heading textone-1",
                      domProps: { innerHTML: _vm._s(item.title) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "textTow" }, [
                  _vm._v(_vm._s(item.abstract))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "last" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.source,
                          expression: "item.source"
                        }
                      ]
                    },
                    [_vm._v("来源：" + _vm._s(item.source))]
                  ),
                  _vm._v(" "),
                  item.author && _vm.clientId == 410600
                    ? _c("span", [_vm._v("编辑：" + _vm._s(item.author))])
                    : _vm._e(),
                  _vm._v(" "),
                  item.author && _vm.clientId !== 410600
                    ? _c("span", [_vm._v("作者：" + _vm._s(item.author))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.released_at,
                          expression: "item.released_at"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.friendlyTime(item.released_at, "mohu", 1))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (item.views || item.views == 0) &&
                            !(_vm.clientId == 321300 || _vm.clientId == 320100),
                          expression:
                            "(item.views||item.views==0)&&(!(clientId==321300||clientId==320100))"
                        }
                      ],
                      staticClass: "views"
                    },
                    [_vm._v(_vm._s(item.views) + "人阅读")]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        item.news_type == 4
          ? _c("div", { staticClass: "media media-2" }, [
              _c("div", { staticClass: "media-left" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "/news/topic/" + item.id, target: "_blank" }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: {
                            loading: _vm.lazyLoading,
                            error: _vm.lazyLoading,
                            src: item.img_url[0]
                          },
                          expression:
                            "{\n                        loading: lazyLoading,\n                        error: lazyLoading,\n                        src: item.img_url[0]\n                      }"
                        }
                      ],
                      staticClass: "media-object",
                      attrs: { "data-src": "/public/w/img/wap/loading.png" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "media-body elip" }, [
                _vm._v(_vm._s(item.title))
              ])
            ])
          : _vm._e()
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-66491712", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66491712","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-list/public-list.vue
// module id = null
// module chunks = 